import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';
import { store } from 'store';

export const baseURI = 'catalogos/conceptos-de-ingresos/';

/**
 * GET Conceptos de Ingresos
 * @returns {Promise<object[]>}
 */
export const getConceptosDeIngresosLite = async (params = {}, cancelToken) => {
  try {
    const response = await API.get(`${baseURI}conceptos-de-ingresos-pagado/`, { params, cancelToken });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Conceptos de Ingresos
 * @returns {Promise<Array<object>>}
 */
export const getConceptosDeIngresos = async (params = {}, filterByPeriodo = true) => {
  try {
    const { periodoFiscalSelected } = store.getState()?.auth;
    if (filterByPeriodo) {
      // eslint-disable-next-line no-param-reassign
      params.periodo_fiscal = periodoFiscalSelected?.id;
    }
    const response = await API.get(baseURI, { params });
    return {
      ...response.data,
      results: formatReceived(response.data.results),
    };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Concepto de Ingresos
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConceptoDeIngresos = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Concepto de Ingresos
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConceptoDeIngresos = async (values) => {
  try {
    const { periodoFiscalSelected } = store.getState()?.auth;
    // eslint-disable-next-line no-param-reassign
    values.periodo_fiscal = periodoFiscalSelected?.id;
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Concepto de Ingresos
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConceptoDeIngresos = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Concepto de Ingresos
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConceptoDeIngresos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
